import baseURL from "../common/axios";
class LeadSourceService {
    //To Insert LeadSource-->MOPCRM API
    create(dataModel) {
        return baseURL.httpMSMOPCRMUrl.post("LeadSource/Create", dataModel);
    }
    //To Update LeadSource-->MOPCRM API
    update(dataModel) {
        return baseURL.httpMSMOPCRMUrl.post("LeadSource/Update", dataModel);
    }
    //To Delete LeadSource-->MOPCRM API
    delete(Id) {
        return baseURL.httpMSMOPCRMUrl.delete("LeadSource/Delete?id=" + Id);
    }
    //Active
    active(Id, Status) {
        return baseURL.httpMSMOPCRMUrl.put(
            "LeadSource/Active?id=" + Id + "&Status=" + Status + ""
        );
    }
    //To Get LeadSource List-->MOPCRM API
    getList() {
        return baseURL.httpMSMOPCRMUrl.get("LeadSource/List");
    }
    //To Get LeadSource List-->MOPCRM API
    getById(Id) {
        return baseURL.httpMSMOPCRMUrl.get("LeadSource/Get?id=" + Id + "");
    }
}
export default new LeadSourceService();
